import React, { useRef, useEffect, useState } from "react";
import { QRCodeCanvas } from "qrcode.react";
import { useNavigate } from "react-router-dom";

export default function MyQRScreen() {
  const navigate = useNavigate();
  const qrRef = useRef();
  
  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState("");

  useEffect(() => {
    try {
      // Local storage layer se customer data extract karne ke liye
      const savedDataString = localStorage.getItem("userData");
      if (savedDataString) {
        const cleanDataStr = savedDataString.replace("DATABASE CONNECTED", "").trim();
        const parsedData = JSON.parse(cleanDataStr);
        
        // Maps customer structure fields safely
        if (parsedData?.customer) {
          setCustomerId(parsedData.customer.user_id || "CMVC497B3A688");
          setCustomerName(parsedData.customer.name || "Premium Member");
        } else {
          setCustomerId(parsedData.user_id || "CMVC497B3A688");
          setCustomerName(parsedData.name || "Premium Member");
        }
      } else {
        setCustomerId("CMVC497B3A688");
        setCustomerName("Premium Member");
      }
    } catch (error) {
      console.error("Error reading data layer payload inside Customer QR Engine:", error);
      setCustomerId("CUST_991823");
      setCustomerName("Premium Member");
    }
  }, []);

  // Purely passes customer identity string for merchant system evaluation
  const qrValue = customerId;

  const downloadQR = () => {
    const canvas = qrRef.current.querySelector("canvas");
    if (!canvas) return;
    
    const image = canvas.toDataURL("image/png");
    const link = document.createElement("a");
    link.href = image;
    link.download = `${customerName.replace(/\s+/g, "_")}_Loyalty_QR.png`;
    link.click();
  };

  return (
    <div style={styles.container}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;600;700;800&display=swap');
        * { font-family: 'Plus Jakarta Sans', sans-serif; box-sizing: border-box; }
      `}</style>

      {/* TOP NAVIGATION HEADER */}
      <div style={styles.navBar}>
        <div style={styles.navBrand}>💎 My Rewards Pass</div>
        <button style={styles.backBtn} onClick={() => navigate(-1)}>
          ⬅️ Back
        </button>
      </div>

      {/* CUSTOMER LOYALTY CARD ON DEVICE */}
      <div ref={qrRef} style={styles.card}>
        <div style={styles.cardAccent} />
        
        <div style={styles.header}>
          <h1 style={styles.logo}>Count My Visit</h1>
          <p style={styles.subtitle}>Digital Membership Pass</p>
        </div>

        <div style={styles.businessBox}>
          <div style={styles.badge}>LOYALTY MEMBER</div>
          <h2 style={styles.businessNameText}>{customerName}</h2>
          <p style={styles.scanInstruction}>Show this QR code to the Shopkeeper</p>
        </div>

        <div style={styles.qrOuterWrapper}>
          <div style={styles.qrBox}>
            {customerId && (
              <QRCodeCanvas
                value={qrValue}
                size={230}
                level="M"
                includeMargin={true}
                fgColor="#0f172a"
              />
            )}
          </div>
        </div>

        <div style={styles.footer}>
          <p style={styles.footerHighlight}>✨ Member ID: {customerId}</p>
          <small style={styles.poweredBy}>Powered By countmyvisit.com</small>
        </div>
      </div>

      {/* ACTION PANELS */}
      <div style={styles.controlPanel}>
        <button style={styles.button} onClick={downloadQR}>
          📥 Save Pass to Gallery
        </button>
      </div>
    </div>
  );
}

const styles = {
  container: {
    minHeight: "100vh",
    background: "linear-gradient(135deg, #f8fafc 0%, #e2e8f0 100%)",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "24px",
  },
  navBar: {
    width: "100%",
    maxWidth: "430px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    background: "#ffffff",
    padding: "14px 20px",
    borderRadius: "16px",
    boxShadow: "0 4px 15px rgba(15, 23, 42, 0.04)",
    marginBottom: "24px",
    border: "1px solid #e2e8f0",
  },
  navBrand: { fontSize: "14px", fontWeight: "700", color: "#0f172a" },
  backBtn: {
    background: "#f1f5f9", border: "none", padding: "8px 14px",
    borderRadius: "10px", fontSize: "12px", fontWeight: "700",
    color: "#475569", cursor: "pointer", transition: "0.2s",
  },
  card: {
    width: "100%", maxWidth: "430px", background: "#ffffff",
    borderRadius: "32px", padding: "40px 32px", textAlign: "center",
    boxShadow: "0 25px 50px -12px rgba(15, 23, 42, 0.12)",
    position: "relative", overflow: "hidden", border: "1px solid #f1f5f9",
  },
  cardAccent: {
    position: "absolute", top: 0, left: 0, right: 0, height: "8px",
    background: "linear-gradient(90deg, #ff8c42, #ff5e62)",
  },
  header: { marginBottom: "28px" },
  logo: {
    margin: 0, fontSize: "26px", fontWeight: "800", letterSpacing: "-0.5px",
    background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
    WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent",
  },
  subtitle: {
    margin: "4px 0 0 0", color: "#64748b", fontSize: "13px",
    fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.75px",
  },
  businessBox: { marginBottom: "24px" },
  badge: {
    display: "inline-block", background: "#fff7ed", color: "#ea580c",
    fontSize: "10px", fontWeight: "800", padding: "4px 10px",
    borderRadius: "20px", letterSpacing: "0.5px", marginBottom: "10px",
  },
  businessNameText: {
    margin: 0, fontSize: "28px", fontWeight: "800", color: "#0f172a",
    textTransform: "capitalize", lineHeight: "1.2",
  },
  scanInstruction: { margin: "8px 0 0 0", color: "#64748b", fontSize: "14px", fontWeight: "500" },
  qrOuterWrapper: {
    display: "flex", justifyContent: "center", alignItems: "center",
    background: "#f8fafc", padding: "20px", borderRadius: "24px",
    border: "2px dashed #cbd5e1", marginBottom: "28px",
  },
  qrBox: {
    background: "#ffffff", padding: "12px", borderRadius: "16px",
    boxShadow: "0 10px 25px rgba(0, 0, 0, 0.04)",
  },
  footer: { marginTop: "12px" },
  footerHighlight: { margin: 0, fontSize: "14px", fontWeight: "700", color: "#475569" },
  poweredBy: {
    display: "block", marginTop: "8px", color: "#94a3b8", fontSize: "11px",
    fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.5px",
  },
  controlPanel: { width: "100%", maxWidth: "430px", textAlign: "center" },
  button: {
    marginTop: "12px", width: "100%", height: "54px",
    background: "linear-gradient(135deg, #ff8c42, #ff5e62)",
    color: "#ffffff", border: "none", borderRadius: "14px", cursor: "pointer",
    fontSize: "16px", fontWeight: "600", transition: "all 0.2s ease",
    boxShadow: "0 10px 20px -5px rgba(255, 94, 98, 0.3)",
  },
  statusCard: {
    marginTop: "5px", padding: "14px", borderRadius: "14px",
    border: "1px dashed #ff8c42", textAlign: "left", marginBottom: "20px",
  },
  urlLabel: { display: "block", fontSize: "10px", fontWeight: "800", color: "#64748b", letterSpacing: "0.5px" },
  urlText: { margin: 0, fontSize: "13px", color: "#334155", wordBreak: "break-all" },
};